import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

import { CanvasToolbarIconComponent } from '../../../icons/canvas-toolbar-icon.component';

@Component({
  selector: 'lib-canvas-measure-tool',
  standalone: true,
  imports: [CanvasToolbarIconComponent],
  template: `
    <button
      class="cv-tb__btn"
      [class.cv-tb__btn--active]="active"
      (click)="measure.emit()"
      title="Measure distance"
      type="button"
    >
      <lib-canvas-toolbar-icon name="ruler"></lib-canvas-toolbar-icon>
    </button>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class MeasureToolComponent {
  @Input() active = false;
  @Output() measure = new EventEmitter<void>();
}
